import soul1 from'../assets/diseases/soul1.png'
import soul2 from'../assets/diseases/soul2.png' 
import soul3 from'../assets/diseases/soul3.png'
import eye1 from'../assets/diseases/eye1.png'
import eye2 from'../assets/diseases/eye2.png' 
import eye3 from'../assets/diseases/eye3.png' 
import covid1 from'../assets/diseases/covid1.png'
import covid2 from'../assets/diseases/covid2.png'
import covid3 from'../assets/diseases/covid3.png' 
import heart1 from'../assets/diseases/heart1.png'
import heart2 from'../assets/diseases/heart2.png' 
import heart3 from'../assets/diseases/heart3.png' 
import child1 from'../assets/diseases/child1.png'
import child2 from'../assets/diseases/child2.png' 
import child3 from'../assets/diseases/child3.png'
import nutri1 from'../assets/diseases/nutri1.png'
import nutri2 from'../assets/diseases/nutri2.png'
import nutri3 from'../assets/diseases/nutri3.png' 
import dental1 from'../assets/diseases/dental1.png'
import dental2 from'../assets/diseases/dental2.png'
import dental3 from'../assets/diseases/dental3.png' 

const titleCard=[
    {
        id:"soul",
        title:"SOUL CARE",
        subtitle:"Get assistance on your mental health issues, including stress, anxiety, and depression, with our specialists",
        img1:soul1,
        img2:soul2,
        img3:soul3,
    },
    {
        id:"covid",
        title:"COVID CARE",
        subtitle:"Get help with Covid 19. Connect to our experts on Covid 19 symptoms and it’s precaution",
        img1:covid1,
        img2:covid2,
        img3:covid3,
    },
    {
        id:"heart",
        title:"HEART CARE",
        subtitle:"We offer convenience to your heart care with Impulse-12, a Premium Portable 12-channek ECG Machine",
        img1:heart1,
        img2:heart2,
        img3:heart3,
    },
    {
        id:"child",
        title:"CHILD CARE",
        subtitle:"Get help from Pediatricians who manages the health of children including behavioural, physical and mental issues",
        img1:child1,
        img2:child2,
        img3:child3,
    },
    {
        id:"nutri",
        title:"NUTRI CARE",
        subtitle:"Get assistance on your diet and eating disorders by nutrition specialist to improve your physical health",
        img1:nutri1,
        img2:nutri2,
        img3:nutri3,
    },
    {
        id:"eye",
        title:"EYE CARE",
        subtitle:"Get assistance from Eye care specialist who prescribes vision aids and recognize serious optical diseases",
        img1:eye1,
        img2:eye2,
        img3:eye3,
    },
    {
        id:"dental",
        title:"DENTAL CARE",
        subtitle:"Get assistance on Dental health, book appointment with Dentists who prescribes aids and diagnose serious issues",
        img1:dental1,
        img2:dental2,
        img3:dental3,
    },
];

export default titleCard